import { PropositionSection, TrackingMeta } from '@ecosystem/newron-core/types';
import { InternalEventParams } from './types';
import { Proposition } from '../../utils/constants';

export const mapCoreMetaParams = (
  proposition: string,
  meta: TrackingMeta,
  subsection: string,
  pageName: string
): InternalEventParams => {
  // cell information
  // format is ['BE-DEC_GARDEN_PRES']
  const cells = meta.pageContext.cell || [];

  const splitCells = cells.map(c => {
    const parts = c.split('-');
    return { country: parts[0], itemGroup: parts[1] };
  });

  const cellsFormatted = splitCells.map(({ country, itemGroup }) => `${country}/${itemGroup}`);
  const countries = Array.from(new Set(splitCells.map(o => o.country)));
  const itemGroups = Array.from(new Set(splitCells.map(o => o.itemGroup)));
  const periodicity = meta.pageContext.timeFrame ? meta.pageContext.timeFrame[0].split(':')[0] : '';

  const currentSection: PropositionSection =
    proposition === Proposition.DistributionPanel ? 'Supply Chain' : 'Market 2.0';

  return {
    section: currentSection,
    subsection,
    pageName,
    cells: cellsFormatted,
    periodicity,
    itemGroup: itemGroups,
    locationId: countries,
    numberOfCells: cells.length.toString(),
    cellAggregation: cells.length > 1 ? 'multicell' : 'singlecell',
    locationIdAggregation: countries.length > 1 ? 'many' : 'single',
    itemGroupAggregation: itemGroups.length > 1 ? 'many' : 'single',
    proposition,
    ...meta.eventParams,
  };
};

/**
 * Maps internal market 2 tab names (ie. scorecard, time, segments) to their tracking equivalents
 *
 * @param tabName
 * @returns
 */
export const mapTabName = (tabName: string): string => {
  const lookup = {
    segments: 'Segmentation',
    time: 'Time Series',
    scorecard: 'Scorecard',
  };
  return lookup[tabName] ?? tabName;
};

/**
 * Splits a timeframe parameter value into its consistuent parts
 */
export const splitTimeframeValue = (paramValue: string | string[]) => {
  const [aggregation = '', sequenceInfo = '', aggregationMethod = ''] = (
    Array.isArray(paramValue) ? paramValue[0] : paramValue
  ).split(':');

  let aggregationValue: string = aggregation;
  let aggregationMethodValue: string = aggregationMethod;

  switch (aggregationMethod) {
    case 'Year':
    case 'MAT':
    case 'YTD':
      aggregationValue = 'Year';
      break;
    case 'Quarter':
    case 'RollingQuarter':
      aggregationValue = 'Quarter';
      aggregationMethodValue = 'Rolling Quarter';
      break;
  }

  return {
    aggregation: aggregationValue,
    aggregationMethod: aggregationMethodValue,
    sequenceInfo,
  };
};

export const addTimeAggregationValues = (params: InternalEventParams, timeFrameValue: string | string[]): void => {
  const split = splitTimeframeValue(timeFrameValue);
  params.timeAggregation = split.aggregation;
  params.timeAggregationMethod = split.aggregationMethod;
};
